import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["aria-label", "disabled"];
const _hoisted_2 = { class: "rec-setting__label" };
const _hoisted_3 = ["aria-label", "aria-expanded", "disabled"];
const _hoisted_4 = { class: "rec-setting__menu__heading" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "rec-setting__menu__item__label" };
const _hoisted_7 = {
    key: 1,
    class: "rec-setting__menu__item__volume"
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "rec-setting__menu__heading" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "rec-setting__menu__item__label" };
import { vTooltip } from "@/common/directives/tip-directive";
import { onClickOutside, onKeyStroke, useIntersectionObserver, useVModel } from "@vueuse/core";
import { computed, inject, nextTick, ref } from "vue";
// Components
import SvgIcon from "@/common/components/SvgIcon.vue";
import { MediaSource } from "../types";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeviceInputSelect',
    props: {
        inputDeviceId: { default: "" },
        audioMeter: { default: undefined },
        disabled: { type: Boolean, default: false },
        muted: { type: Boolean },
        preventChange: { type: Boolean, default: false },
        inputs: {},
        type: {},
        backgroundBlurAmount: { default: undefined }
    },
    setup(__props) {
        // Scripts
        const i18n = inject("i18n");
        const props = __props;
        const backgroundBlurAmountModel = useVModel(props, "backgroundBlurAmount");
        const inputDeviceIdVModel = useVModel(props, "inputDeviceId");
        const mutedModel = useVModel(props, "muted");
        const toggleMute = () => {
            if (props.preventChange)
                return;
            mutedModel.value = !mutedModel.value;
        };
        const volumeLevelWidth = computed(() => "width: " + props.audioMeter?.volumeLevel.value + "%;");
        const menuOpen = ref(false);
        const dropdown = ref(null);
        const menu = ref(null);
        const menuButton = ref(null);
        const inputRefs = ref([]);
        const blurRefs = ref([]);
        onClickOutside(menu, () => {
            if (menuOpen.value) {
                handleToggleMenu();
            }
        }, {
            ignore: [menuButton]
        });
        const positionMenu = (entries) => {
            const entry = entries[0];
            const { left, right } = entry.boundingClientRect;
            const viewportWidth = window.innerWidth;
            const isOutsideViewport = left < 0 || right > viewportWidth;
            if (isOutsideViewport && menu.value) {
                let offset = -left + 13;
                let percent = "-50%";
                if (window.Ramius.is_rtl) {
                    offset = viewportWidth - right - 13;
                    percent = "50%";
                }
                menu.value.style.transform = `translateX(calc(${percent} + ${offset}px))`;
            }
        };
        useIntersectionObserver(menu, positionMenu, { root: null });
        const handleToggleMenu = () => {
            menuOpen.value = !menuOpen.value;
            if (!menuOpen.value && menu.value) {
                menu.value.style.transform = "";
                //props.audioMeter.listen(menuOpen.value, uid.value);
            }
            else {
                currentFocus.value = 0;
                focusMenuItem();
            }
        };
        const selectInput = (deviceId) => {
            inputDeviceIdVModel.value = deviceId;
        };
        const isActive = (deviceId) => {
            return deviceId == props.inputDeviceId;
        };
        const buttonTooltip = computed(() => props.preventChange
            ? i18n.t("Camera cannot be disabled")
            : props.type === MediaSource.Audio
                ? props.muted
                    ? i18n.t("Enable Mic")
                    : i18n.t("Disable Mic")
                : props.muted
                    ? i18n.t("Enable Camera")
                    : i18n.t("Disable Camera"));
        const buttonClasses = computed(() => ({
            "rec-setting__button": true,
            "rec-setting__button--has-submenu": true,
            "rec-setting__button--off": props.muted,
            "rec-setting__button--prevent-change": props.preventChange
        }));
        const buttonLabel = computed(() => (props.type === MediaSource.Audio ? i18n.t("Mute") : i18n.t("Camera")));
        const buttonIcon = computed(() => props.type === MediaSource.Audio
            ? props.muted
                ? "icon-mic-off"
                : "icon-mic"
            : props.muted
                ? "icon-webcam-off"
                : "icon-webcam");
        onKeyStroke("Escape", (e) => {
            if (!menuOpen.value)
                return;
            e.stopPropagation();
            handleToggleMenu();
        }, { target: dropdown });
        const currentFocus = ref(0);
        const focusMenuItem = () => {
            nextTick(() => {
                const allRefs = [...inputRefs.value, ...blurRefs.value];
                allRefs[currentFocus.value]?.focus();
            });
        };
        onKeyStroke("ArrowDown", (e) => {
            e.preventDefault();
            if (!menuOpen.value) {
                handleToggleMenu();
                return;
            }
            const totalItems = inputRefs.value.length + blurRefs.value.length;
            currentFocus.value = (currentFocus.value + 1) % totalItems;
            focusMenuItem();
        }, { target: dropdown });
        onKeyStroke("ArrowUp", (e) => {
            e.preventDefault();
            if (!menuOpen.value) {
                handleToggleMenu();
                return;
            }
            const totalItems = inputRefs.value.length + blurRefs.value.length;
            currentFocus.value = (currentFocus.value - 1 + totalItems) % totalItems;
            focusMenuItem();
        }, { target: dropdown });
        const blurAmounts = [0, 4, 8];
        const setBlurBackground = (amount) => {
            backgroundBlurAmountModel.value = amount;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "dropdown",
                ref: dropdown,
                class: _normalizeClass(`rec-setting rec-setting--${_ctx.type}`)
            }, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                    "aria-label": buttonTooltip.value,
                    type: "button",
                    class: _normalizeClass(buttonClasses.value),
                    disabled: _ctx.disabled,
                    onClick: toggleMute
                }, [
                    _createVNode(SvgIcon, {
                        icon: buttonIcon.value,
                        class: "rec-setting__button__icon"
                    }, null, 8, ["icon"])
                ], 10, _hoisted_1)), [
                    [
                        _unref(vTooltip),
                        buttonTooltip.value,
                        void 0,
                        { large: true }
                    ]
                ]),
                _createElementVNode("div", _hoisted_2, _toDisplayString(buttonLabel.value), 1),
                _createElementVNode("div", {
                    class: _normalizeClass(["rec-setting__menu-wrap", { 'rec-setting__menu-wrap--open': menuOpen.value }])
                }, [
                    _createElementVNode("button", {
                        ref_key: "menuButton",
                        ref: menuButton,
                        type: "button",
                        class: "rec-setting__button rec-setting__button--small",
                        "aria-label": _ctx.type === _unref(MediaSource).Audio ? _ctx.$t('Mic Settings') : _ctx.$t('Camera Settings'),
                        "aria-haspopup": "menu",
                        "aria-expanded": menuOpen.value,
                        disabled: _ctx.disabled,
                        onClick: handleToggleMenu
                    }, [
                        _createVNode(SvgIcon, {
                            icon: "icon-right-angle-down",
                            class: "rec-setting__button__icon rec-setting__button__icon--chevron"
                        })
                    ], 8, _hoisted_3),
                    (menuOpen.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref_key: "menu",
                            ref: menu,
                            role: "menu",
                            class: "rec-setting__menu"
                        }, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.type === _unref(MediaSource).Audio ? _ctx.$t("Microphone") : _ctx.$t("Camera")), 1),
                            _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (input) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        key: input.deviceId,
                                        ref_for: true,
                                        ref_key: "inputRefs",
                                        ref: inputRefs,
                                        type: "button",
                                        role: "menuitem",
                                        class: _normalizeClass(["rec-setting__menu__item", [{ 'rec-setting__menu__item--active': isActive(input.deviceId) }]]),
                                        onClick: ($event) => (selectInput(input.deviceId))
                                    }, [
                                        (isActive(input.deviceId))
                                            ? (_openBlock(), _createBlock(SvgIcon, {
                                                key: 0,
                                                icon: "icon-check-3",
                                                class: "rec-setting__menu__item__check"
                                            }))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(input.label), 1),
                                        (_ctx.type === _unref(MediaSource).Audio && isActive(input.deviceId))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                _createElementVNode("div", {
                                                    role: "progressbar",
                                                    class: "rec-setting__menu__item__volume__progress",
                                                    style: _normalizeStyle(volumeLevelWidth.value)
                                                }, null, 4)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 10, _hoisted_5));
                                }), 128))
                            ]),
                            (_ctx.type === _unref(MediaSource).Video && _ctx.backgroundBlurAmount !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("Blur Background")), 1),
                                    _createElementVNode("div", null, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(blurAmounts, (amount, index) => {
                                            return _createElementVNode("button", {
                                                key: amount,
                                                ref_for: true,
                                                ref_key: "blurRefs",
                                                ref: blurRefs,
                                                type: "button",
                                                role: "menuitem",
                                                class: _normalizeClass(["rec-setting__menu__item", [{ 'rec-setting__menu__item--active': amount === _ctx.backgroundBlurAmount }]]),
                                                onClick: ($event) => (setBlurBackground(amount))
                                            }, [
                                                (amount === _ctx.backgroundBlurAmount)
                                                    ? (_openBlock(), _createBlock(SvgIcon, {
                                                        key: 0,
                                                        icon: "icon-check-3",
                                                        class: "rec-setting__menu__item__check"
                                                    }))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_11, _toDisplayString(index === 0 ? _ctx.$t("Off") : index === 1 ? _ctx.$t("Slight Blur") : _ctx.$t("Heavy Blur")), 1)
                                            ], 10, _hoisted_10);
                                        }), 64))
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ], 512))
                        : _createCommentVNode("", true)
                ], 2)
            ], 2));
        };
    }
});
